import Vue from 'vue';
//common form components
import TextInputGroup from '@/components/form/TextInputGroup.vue';
import NumberInputGroup from '@/components/form/NumberInputGroup.vue';
import PrimaryButton from '@/components/button/PrimaryButton.vue';
import SecondaryButton from '@/components/button/SecondaryButton.vue';
import TertiaryButton from '@/components/button/TertiaryButton.vue';
import PasswordInput from '@/components/form/PasswordInput.vue';
import Select from '@/components/form/Select.vue';
import ErrorMessage from '@/components/alert/ErrorMessage.vue';
import SuccessMessage from '@/components/alert/SuccessMessage.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import WarningButton from '@/components/button/WarningButton.vue';
const formComponents = [
    {
        name: 'TextInputGroup',
        component: TextInputGroup,
    },
    {
        name: 'PasswordInput',
        component: PasswordInput,
    },
    {
        name: 'Select',
        component: Select,
    },
    {
        name: 'NumberInputGroup',
        component: NumberInputGroup,
    },
];
const buttonComponents = [
    {
        name: 'PrimaryButton',
        component: PrimaryButton,
    },
    {
        name: 'SecondaryButton',
        component: SecondaryButton,
    },
    {
        name: 'TertiaryButton',
        component: TertiaryButton,
    },
    {
        name: 'WarningButton',
        component: WarningButton,
    },
];
const alertComponents = [
    {
        name: 'ErrorMessage',
        component: ErrorMessage,
    },
    {
        name: 'SuccessMessage',
        component: SuccessMessage,
    },
    {
        name: 'LoadingIndicator',
        component: LoadingIndicator,
    },
];

const components = [...formComponents, ...buttonComponents, ...alertComponents];

components.forEach((component) => {
    Vue.component(`Common${component.name}`, component.component);
});
